var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.245 3.024-.952 3.813a2 2 0 0 1-1.452 1.455l-2.233.562c-.381.096-.701.353-.878.703a1.353 1.353 0 0 1-2.02.474l-2.96-2.22m10.495-4.787A9.27 9.27 0 0 0 12 2.75a9.25 9.25 0 0 0-8.25 5.062m10.495-4.788A9.25 9.25 0 1 1 3.75 7.811m7.66 8.298-.847-1.268a1.23 1.23 0 0 1 1.103-1.91l.85.054a2 2 0 0 1 .988.335l1.409.948A1.493 1.493 0 0 1 14.08 17h-1.007a2 2 0 0 1-1.664-.89Z"
  })));
};
export default SvgEarth;